import { observer } from "mobx-react-lite";
import styled from "styled-components";
import { Toast } from "antd-mobile";
import useNavigation from "../../hooks/useNavigation";
import { useStores } from "../../models";
import { formatPrice } from "../../utils";
import CreditStatus from "./CreditStatus";
import { payTypeImage } from "./types";

const Box = styled.div`
  background: #fff;
  border-radius: 8px;
  margin: 0 0 2px;
  padding: 10px 12px;
  border-bottom: 2px solid rgb(244, 244, 244);
  cursor: pointer;
`;

const Row = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
`;

const Name = styled.span`
  font-size: 14px;
  font-weight: 700;
  color: #000;
`;

const Price = styled.span`
  font-size: 18px;
  font-weight: 700;
  color: #1c9cea;
`;

const Muted = styled.span`
  font-size: 12px;
  color: rgb(170, 170, 170);
`;

const OrderCard = ({ order, onClick }: { order: any; onClick?: () => void }) => {
  const { navigate } = useNavigation();
  const { userStore } = useStores();
  const {
    quantities,
    stock,
    amount,
    min_trading,
    max_trading,
    payment_methods,
    user_id,
    name,
    credit_score,
  } = order || {};

  const total = Number(quantities) || 0;
  const _stock = Number(stock) || 0;
  const content =
    "成单量 " +
    (total - _stock).toString() +
    " | " +
    (total ? Math.round((_stock / total) * 10000) / 100 : 0) +
    "%";

  const isMyCard = userStore.currentUser?.id === user_id;

  const handleClick = () => {
    if (onClick) return onClick();
    if (isMyCard) {
      Toast.show({ content: "不能购买自己发起的订单" });
      return;
    }
    navigate("PayDetail", { order_no: order.order_no });
  };

  return (
    <Box onClick={handleClick}>
      <Row>
        <div style={{ display: "flex", alignItems: "center" }}>
          <Name>
            {name}
            {isMyCard ? "(我)" : ""}
          </Name>
          <CreditStatus credit_score={credit_score} />
        </div>
        <Muted>{content}</Muted>
      </Row>

      <Row style={{ marginTop: 8, justifyContent: "flex-end" }}>
        <div>
          <Muted style={{ color: "#1c9cea" }}>¥ </Muted>
          <Price>{formatPrice(amount)}</Price>
          <Muted> / 单价</Muted>
        </div>
      </Row>

      <Row style={{ marginTop: 4 }}>
        <Muted>
          数量 {formatPrice(stock)} 喜鹊币
        </Muted>
      </Row>

      <Row style={{ marginTop: 4 }}>
        <Muted>
          限额 {formatPrice(min_trading)} - {formatPrice(max_trading)} 喜鹊币
        </Muted>
        <div style={{ display: "flex", alignItems: "center" }}>
          {(payment_methods || []).map((type: number, i: number) => (
            <img
              key={`${type}-${i}`}
              src={payTypeImage(type)}
              alt=""
              width={20}
              height={20}
              style={{ marginLeft: 5, borderRadius: 5 }}
            />
          ))}
        </div>
      </Row>
    </Box>
  );
};

export default observer(OrderCard);
